export function PencilPuristIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M16 8l-4 32" />
      <path d="M12 40l2-2 2 2" />
      <path d="M16 8l6 3-2 6" />
      <path d="M28 12l8 24" />
      <line x1="24" y1="28" x2="40" y2="28" />
    </svg>
  );
}
